import Vue from 'vue';
import Vuex from 'vuex';
import { appState } from '@/application/app/store';
import { breadcrumbState } from '@/application/breadcrumb/store';
import { snackbarState } from '@/application/snackbar/store';
import { authenticationState } from '@/application/authentication/store';
import { productSearchState } from '@/domain/product-search/store';
import { orderSearchState } from '@/domain/order-search/store';
import { addressCorrectionState } from '@/domain/address-correction/store';
import { Store } from './types';

Vue.use(Vuex);

export const store = new Vuex.Store<Store>({
  modules: {
    app: appState,
    authentication: authenticationState,
    breadcrumb: breadcrumbState,
    snackbar: snackbarState,
    productSearch: productSearchState,
    orderSearch: orderSearchState,
    addressCorrection: addressCorrectionState,
  }
});
